import { get, post, path_version, ENCRYPT_TYPES } from '@/httpRequest/http'
const { VUE_APP_OPEN_ACCOUNT, VUE_APP_OPERATION, VUE_APP_UC } = process.env
import { getBaseUrl } from '@/utils'
import JSBridge from '@fs/jsbridge/dist/lib/jsBridge.js'
const baseUrl = getBaseUrl(VUE_APP_OPEN_ACCOUNT)
const baseUrl_o = getBaseUrl(VUE_APP_OPERATION)
const baseUrl_1 = getBaseUrl(VUE_APP_UC)

/** 查询用户的账号信息及现金宝开户申请状态。 */
export const FtdState = data => {
    return post(baseUrl + `/account/${path_version}/FtdState`, {
        data,
        showFreezeToast: false,
    })
}

/** 获取现金宝开户风险披露声明 */
export const GetRiskDisclosureInfo = params => {
    return get(baseUrl + `/account/${path_version}/GetRiskDisclosureInfo`, {
        params,
    })
}

/** 提交现金宝开户申请 */
export const FtdSubmit = data => {
    return post(baseUrl + `/account/${path_version}/FtdSubmit`, {
        data,
        encTag: JSBridge ? 'tradeverify/enc' : 'trade/enc',
        isTrade: true,
    })
}

/** 现金宝重新提交 */
export const FtdReSubmit = data => {
    return post(baseUrl + `/account/${path_version}/FtdReSubmit`, {
        data,
    })
}

/** 现金宝获取授权人 */
export const GetCorpAuthorizers = params => {
    return get(baseUrl + `/account/${path_version}/GetCorpAuthorizers`, {
        params,
    })
}
/**
 * @name 定存宝订阅状态查询
 * @link https://www.tapd.cn/60236733/markdown_wikis/show/#1160236733001005513
 */
export const ftdSubscribeStatus = (params = {}) => {
    return get(`${baseUrl_o}/newActivity/fixedfund/${path_version}/subscribe_status`, { params })
}

// 定存宝订阅/取消订阅接口
export const ftdSubscribeReminder = data => {
    return post(baseUrl_o + `/newActivity/fixedfund/${path_version}/subscribe`, {
        data,
    })
}
export const ClientContractSign = (data, config = {}) => {
    return post(`${baseUrl_1}/uc/v1/ClientContractSign`, { data, ...config, encrypt: ENCRYPT_TYPES.LOGIN })
}
